module.exports = __webpack_public_path__ + "img/19b)(NH Hotel)Montage von über 300 Gästezimmer.jpg";